import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibCheckbox } from '@chewy/kib-choices-react'

import type { AttachmentHistoryItem } from '~/types'

import '@chewy/kib-choices-styles/dist/styles/kib-checkbox.css'
import styles from './AttachmentMenuItem.module.scss'

interface AttachmentMenuItemProps {
  attachment: AttachmentHistoryItem
  checked: boolean
  disabled?: boolean
  onChange: (nextValue: boolean) => void
}

export const AttachmentMenuItem = ({
  attachment,
  checked,
  disabled = false,
  onChange,
}: AttachmentMenuItemProps) => {
  const { t } = useTranslation(['Common'])
  const label =
    attachment.name ||
    attachment.fileName ||
    attachment.originalFileName ||
    t('Common:ATTACHMENT')

  return (
    <KibCheckbox
      className={styles.checkbox}
      disabled={disabled}
      label={label}
      selectedValue={checked}
      onChange={(value) => onChange(Boolean(value))}
    />
  )
}
